module.exports = __webpack_public_path__ + "static/media/GoogleEmojis.e4ffe3a4.ttf";